export const mutations = {
  setCalendarTripRequests(state, tripRequests) {
    state.calendarTripRequests = tripRequests;
  },
  setCalendarAssignments(state, assignments) {
    state.calendarAssignments = assignments;
  },
};
